import { render, staticRenderFns } from "./categories-item.component.vue?vue&type=template&id=767d1b74&scoped=true"
import script from "./categories-item.component.vue?vue&type=script&lang=ts"
export * from "./categories-item.component.vue?vue&type=script&lang=ts"
import style0 from "./categories-item.component.vue?vue&type=style&index=0&id=767d1b74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767d1b74",
  null
  
)

export default component.exports